<h2 mat-dialog-title class="">{{ ctx.title | translate }}</h2>

<mat-dialog-content>
    <p>{{ctx.text | translate }}</p>
    <app-file-uploader [control]="ctx.control" [maxFileSize]="ctx.maxFileSize" [fileFormats]="ctx.fileFormats" [multiple]="ctx.multiple" [view_mode]="ctx.view_mode" />
</mat-dialog-content>

<mat-dialog-actions class="w-full flex justify-between">
    <button mat-flat-button mat-dialog-close class="bg-tw-lightgrey flex-grow"><span class="">{{ 'CANCEL' | translate }}</span></button>
    <button mat-flat-button [mat-dialog-close]="true" class="bg-tw-primary text-tw-text-light flex-grow"><span class="">{{ 'UPLOAD' | translate}}</span></button>
</mat-dialog-actions>